import { useEffect } from 'react'

export function useSEO({ title, description, ogImage, canonicalUrl }) {
  useEffect(() => {
    // Document title
    if (title) {
      document.title = title
    }

    // Helper to set meta tag
    const setMeta = (name, content, isProperty = false) => {
      if (!content) return
      const selector = isProperty ? `meta[property="${name}"]` : `meta[name="${name}"]`
      let tag = document.querySelector(selector)
      if (!tag) {
        tag = document.createElement('meta')
        if (isProperty) {
          tag.setAttribute('property', name)
        } else {
          tag.setAttribute('name', name)
        }
        document.head.appendChild(tag)
      }
      tag.setAttribute('content', content)
    }

    if (description) {
      setMeta('description', description)
      setMeta('og:description', description, true)
      setMeta('twitter:description', description)
    }

    if (title) {
      setMeta('og:title', title, true)
      setMeta('twitter:title', title)
    }

    if (ogImage) {
      setMeta('og:image', ogImage, true)
      setMeta('twitter:image', ogImage)
      setMeta('twitter:card', 'summary_large_image')
    }

    // Canonical link
    if (canonicalUrl) {
      let link = document.querySelector('link[rel="canonical"]')
      if (!link) {
        link = document.createElement('link')
        link.setAttribute('rel', 'canonical')
        document.head.appendChild(link)
      }
      link.setAttribute('href', canonicalUrl)
    }
  }, [title, description, ogImage, canonicalUrl])
}
